<template>
    <div class=" text-xs lg:text-lg w-full lg:p-2 lg:px-5">
    
        <div class="flex flex-col items-center justify-around text-center
        rounded lg:rounded-lg lg:h-64 w-full p-2 mt-1 lg:mt-2">

            <div class="w-full flex flex-col justify-center">
                
                <div class="mb-5 lg:mb-5 mt-5">
                    <label class="bg-blue-300 p-1 lg:p-2 rounded lg:rounded-full border-blue-800
                    border lg:border-2 mr-2 lg:mr-5 w-32 lg:w-48 ">{{$t('payment.packageType')}}</label>
                </div>

                <div class="flex lg:flex-row items-center lg:justify-around flex-col w-full lg:h-64">

                    <div @click="selectValue(1)" class="myPaymentBorder flex flex-col items-center w-48 lg:w-40 mb-5 lg:mb-0">
                    
                        <input type="radio" v-model="radioValue" class="mt-2" value="10">
                        <label class="text-pink-800 mb-4">{{$t('payment.tenPoints')}}</label>
                        <label class="bg-blue-600 rounded p-1 text-white w-32 lg:w-40 mb-2">{{$t('payment.fiveHalfKd')}}</label>
                    </div>

                    <div @click="selectValue(2)" class="myPaymentBorder flex flex-col items-center justify-center w-48 lg:w-40 mb-5 lg:mb-0">

                        <input type="radio" v-model="radioValue" class="mt-2" value="20">
                        <label class="text-pink-800 mb-4">{{$t('payment.twentyPoints')}}</label>
                        <label class="bg-blue-600 rounded p-1 text-white w-32 lg:w-40 mb-2" >{{$t('payment.thenHalfKd')}}</label>
                    </div>
                    
                    <div @click="selectValue(3)"
                     class="myPaymentBorder flex flex-col items-center justify-center w-48 lg:w-40 mb-5 lg:mb-0">

                        <input type="radio" v-model="radioValue" class="mt-2" value="40">
                        <label class="text-pink-800 mb-4">{{$t('payment.fortyPoints')}}</label>
                        <label class="bg-blue-600 rounded p-1 text-white w-32 lg:w-40 mb-2" >{{$t('payment.twentyQuarterKd')}}</label>
                    </div>

                    <div @click="selectValue(4)" class="myPaymentBorder flex flex-col items-center justify-center w-48 lg:w-40 mb-5 lg:mb-0">

                        <input type="radio" v-model="radioValue" class="mt-2" value="82">
                        <label class="text-pink-800 mb-4">{{$t('payment.eightyTwo')}}</label>
                        <label class="bg-blue-600 rounded p-1 text-white w-32 lg:w-40 mb-2" >{{$t('payment.fortyKd')}}</label>
                    </div>

                    <div @click="selectValue(5)" class="myPaymentBorder flex flex-col items-center justify-center w-48 lg:w-40 mb-5 lg:mb-0">

                        <input type="radio" v-model="radioValue" class="mt-2" value="165">
                        <label class="text-pink-800 mb-4">{{$t('payment.oneSixtyFive')}}</label>
                        <label class="bg-blue-600 rounded p-1 text-white w-32 lg:w-40 mb-2" >{{$t('payment.eightyKd')}}</label>
                    </div>

                    <!-- <div @click="selectValue(6)" class="myPaymentBorder flex flex-col items-center justify-center w-48 lg:w-40 mb-5 lg:mb-0">

                        <input type="radio" v-model="radioValue" class="mt-2" value="333">
                        <label class="text-pink-800 mb-4">{{$t('payment.threeThrees')}}</label>
                        <label class="bg-blue-600 rounded p-1 text-white w-32 lg:w-40 mb-2" >{{$t('payment.oneSixtyKd')}}</label>
                    </div> -->
                </div>

            </div>
        </div>

        <div class="mt-5 lg:mt-10 flex flex-col bg-blue-400 text-white p-1 lg:p-2 rounded lg:rounded-lg justify-center text-center w-full">

            <div>
                <label >{{$t('profile.paymentOptions')}}</label>

            </div>

            <div class="flex">
                <div class="w-full">
                <ul class="flex lg:flex-row flex-col mb-0 list-none flex-wrap pt-3 pb-4">
                    <li v-if ="$countryCode == 'KW'" class="mb-2 mr-2 last:mr-0 flex-auto text-center lg:mb-0">
                    <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(1)"
                     v-bind:class="{'text-pink-600 bg-blue-100': openTab !== 1, 'text-white bg-pink-600': openTab === 1}">
                        <i class="fas fa-space-shuttle text-base mr-1"></i> {{$t('payment.payPal')}}
                    </a>
                    </li>
                    <li v-if ="$countryCode == 'KW'" class="mb-2 mr-2 last:mr-0 flex-auto text-center lg:mb-0">
                    <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(2)"
                     v-bind:class="{'text-pink-600 bg-blue-100': openTab !== 2, 'text-white bg-pink-600': openTab === 2}">
                        <i class="fas fa-cog text-base mr-1"></i> {{$t('payment.creditCard')}}
                    </a>
                    </li>
                    <li class="mr-2 last:mr-0 flex-auto text-center">
                    <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(3)"
                     v-bind:class="{'text-pink-600 bg-white': openTab !== 3, 'text-white bg-pink-600': openTab === 3}">
                        <i class="fas fa-briefcase text-base mr-1"></i> {{$t('payment.knet')}}
                    </a>
                    </li>
                </ul>
                </div>
            </div>
        </div>

                        
        <div class="mt-1 lg:mt-2 w-full flex justify-center">

            <div v-if="loading">
        
                <ring-loader ></ring-loader> 
            </div>
            
            <button v-else class="myBookButton mt-2 mb-2" @click="submitPayment()">
                {{$t('business.submit')}}</button>
        </div>
    </div>
</template>

<script>

// import PaypalPayment from './PaypalPayments'
import authHttpHelper from '../auth/auth-http-helper'
import componentsHelpers from '../classes/componentHelpers';
import moment from 'moment';

// import axios from '@/classes/myAxios'
import axios from '@/classes/myAxios'


import { RingLoader } from 'vue-spinners-css';

export default {

    mounted(){

        this.openTab = 3;
    },

    props:{

        userId:0
    },

    components: {

        // PaypalPayment,
        RingLoader
    },

    methods: {

        selectValue(index){

            if(index == 1){

                this.radioValue = 10;

            }else if(index == 2){

                this.radioValue = 20;
            }else if(index == 3){

                this.radioValue = 40;

            }else if(index == 4){

                this.radioValue = 82;
            }

            else if(index == 5){

                this.radioValue = 165;
            }

             else if(index == 6){

                this.radioValue = 333;
            }

            // console.log(`index: ${index}, value: ${this.radioValue}`);
        },

        async submitPayment(){

            const timeNow = moment(new Date());

            const firstTime = moment('23:45:00', 'HH:mm:ss');

            const secondTime = moment('23:59:59', 'HH:mm:ss');;

            if(moment(timeNow).isBetween(firstTime, secondTime, undefined, '[]')){

                componentsHelpers.toastIt(this.$toasted, this.$t('profile.serviceDisabled'), 3, 'bubble', true);

                return;
            }
           
            try{
                
                this.loading = true;

                const txnTime = new Date().getTime();

                const txnRefNo = this.userId + '0000' + txnTime;

                // const su = 'http://localhost:3000/successfulPayment';

                // const fu = 'http://localhost:3000/failedPayment';

                const su = 'https://www.pnadi.com/successfulPayment';

                const fu = 'https://www.pnadi.com/failedPayment';

                let packageNumber = 2;

                if(this.radioValue == 10){

                    packageNumber = 1;
                }else if(this.radioValue == 20){

                    packageNumber = 2;
                }else if(this.radioValue == 40){

                    packageNumber = 3;
                    
                }else if(this.radioValue == 82){

                    packageNumber = 4;

                }
                
                else if(this.radioValue == 165){

                    packageNumber = 5;
                    
                }
                
                // else if(this.radioValue == 340){

                //     packageNumber = 6;
                // }

                // console.log(`before payment`);
                const paymentResult = await axios({method: 'post',
            
                url: '/pnadiapi/payment/createPayment', 

                data: {
                
                key: authHttpHelper.getKey(),
                txnTime: txnTime,
                txnRefNo: txnRefNo,
                // txnTime: txnTime,
                // txnRefNo: '0000'+ this.userId,
                su: su,
                fu: fu,
                option: 'knet',
                packageNumber: packageNumber,

                }});


                // console.log(`result Result: ${JSON.stringify(paymentResult)}`);

                if(paymentResult.status == 200){

                    if(navigator.userAgent == 'Safari/602.1 ios-pnadi'){

                        this.loading = false;
                    }
                    // console.log(`createdHash Result: ${JSON.stringify(paymentResult.data)}`);

                    if(paymentResult.data.g_status == 1){

                        await window.open(paymentResult.data.knetUrl,"_self");
                        // await window.open(paymentResult.data.knetUrl,"_parent");

                        // window.open(paymentResult.data.knetUrl,"_self", "width=200,height=100");
                    }else{
                       
                        this.loading = false;

                        componentsHelpers.toastIt(this.$toasted, this.$t('payment.somethingWentWrong'), 3, 'bubble', true);
                    }
                }
                else{
                    
                    this.loading = false;

                    componentsHelpers.toastIt(this.$toasted, this.$t('payment.somethingWentWrong'), 3, 'bubble', true);

                    // console.log(`Not in status 200`);
                }

                // this.loading = false;

            }catch(error){

                componentsHelpers.sendError(this.$apollo, this.userId,'Profile', 'PaymentLayout', 'submitPayment', error);

                componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'bubble', true);
                this.loading = false;
            }

        },

        toggleTabs: function(tabNumber){
        
        if(tabNumber == 1 || tabNumber == 2){

          componentsHelpers.toastIt(this.$toasted, this.$t('payment.comingSoon'), 1, 'bubble', true);
        }
        // this.openTab = tabNumber
            if(this.$countryCode == 'KW'){

                this.openTab = 3;
            }else{
                          
                componentsHelpers.toastIt(this.$toasted, this.$t('payment.onlyKuwait'), 1, 'bubble', true);

                // this.openTab = 3;

            }
        }
    },

    data: function() {
    return {
        
        openTab: 1,

        radioValue: 20,

        loading: false,
    }
  },
}
</script>

<style>

</style>